import { 
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {
	envAwarePost
} from '../../util/util'

export const getGroupFeed = createAsyncThunk(
	'getGroupFeed',
	async ()=> envAwarePost('api/notifications/api/',{
		action:'getGroupFeed'
	})
)

export const reactToGroupFeedNotification = createAsyncThunk(
	'reactToGroupFeedNotification',
	async payload => await envAwarePost('api/notifications/api/',{
		action:'reactToNotification',
		...payload
	})
)

export const commentOnGroupFeedNotification = createAsyncThunk(
    'commentOnGroupFeedNotification',
    async payload => await envAwarePost('api/notifications/api/',{
        action: 'commentOnNotification',
		...payload
    })
)

export const postIntoFeed = createAsyncThunk(
    'postIntoFeed',
    async (payload,{dispatch}) => await envAwarePost(
    	'api/notifications/api/',
    	{
        	action: 'postIntoFeed',
			...payload
    	}
    )
)
const groupFeedAdapter = createEntityAdapter({
	status:'idle',
	selectId:entity=>entity.notification_id
})

const groupFeedSlice = createSlice({
	name: 'groupFeed',
	initialState:groupFeedAdapter.getInitialState(),
	reducers: {
		newGroupFeedNotificationReceived:(state,action)=>{
			const {payload:notification} = action
			state.entities[notification.notification_id] = notification
			state.ids.unshift(notification.notification_id)
		},
		newGroupFeedReactionReceived:(state,action)=>{
			const {payload:notification} = action
			state.entities[notification.notification_id] = notification
		},
		newGroupFeedCommentReceived:(state,action)=>{
			const notification = action.payload
			state.entities[notification.notification_id].comments.push(notification)
		}
	},
	extraReducers:{
		[getGroupFeed.pending] : (state)=>{
			state.status='fetching'
		},
		[getGroupFeed.fulfilled] : (state,action)=>{
			state.status='idle'
			const {success,data} = action.payload
			if(success==1 && data) groupFeedAdapter.upsertMany(state,data)
		},
		[getGroupFeed.rejected] : (state)=>{
			state.status='failed'
		},
		[reactToGroupFeedNotification.pending] : (state,action)=>{
			const {arg} = action.meta
			const reaction_data = state.entities[arg.notification_id].reaction_data
			if(arg.reaction_id == reaction_data.recipient_reaction) return 
			if(reaction_data.recipient_reaction !== 'none'){
				reaction_data.reaction_map[reaction_data.recipient_reaction].count -= 1
			}
			reaction_data.recipient_reaction = arg.reaction_id
			reaction_data.reaction_map[arg.reaction_id].count += 1
		},
		[reactToGroupFeedNotification.fulfilled] : (state,action)=>{
			const {success,data,message} = action.payload
			if(success != 1){
				alert(message)
				state.entities[data.notification_id] = data
			}
        },
	}
})

export const {
	newGroupFeedNotificationReceived,
	newGroupFeedReactionReceived,
	newGroupFeedCommentReceived,
} = groupFeedSlice.actions

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllGroupFeed,
	selectById: selectGroupFeedById,
	selectIds: selectGroupFeedIds
} = groupFeedAdapter.getSelectors(state => state.groupFeed)

export default groupFeedSlice.reducer